module.exports = __webpack_public_path__ + "static/media/icon_event_corner.c58ee8e3.svg";